import { apiClient } from "../apiClient"
import { apiConnector } from "../apiConnector"
import toast from "react-hot-toast"
import { setPayment } from "../../slices/payment"


export function Create_Order(payment) {
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", apiClient.CREATE_ORDER, payment, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            return response.data.order
        } catch (error) {
            console.log("Api Calling Error:", error.message)
            toast.error(error.message)
        }
    }
}

export function Verify_Payment(formData){
    const token = localStorage.getItem('token')
    return async(dispatch)=>{
        try {
            const response = await apiConnector('POST',apiClient.VERIFY_PAYMENT,formData,{
                Authorization:`Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error During Verify-Payment Api Calling:",error.message)
            toast.error(error.message)
        }
    }
}

export function Get_Payments(token){
    return async(dispatch)=>{
        try {
            const response = await apiConnector("GET",apiClient.PAYMENT_DETAILS,null,{
                Authorization:`Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            console.log("Payment Details:",response.data.data)
            dispatch(setPayment(response.data.data))
            localStorage.setItem("payments",JSON.stringify(response.data.data))
        } catch (error) {
            console.log("Error Get_Payments Api Calling :",error.message)
            toast.error(error.message)
        }
    }
}



export function SoftwarePlan(payload) {
    console.log("payload software", payload)
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", apiClient.SOFTWAREPLAN_PAYMENT, payload,{
                Authorization:`Bearer ${token}`
            })
            console.log("response_software...",response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response?.data?.message)
            return response
        } catch (error) {
            console.log("Api Calling Error:", error.message)
            toast.error(error.message)
            return error.message
        }
    }
}

export function HardwarePlan(payload) {
    console.log("payload_hardware", payload)
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", apiClient.HARDWAREPLAN_PAYMENT, payload)
            console.log("response hardware...", response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success(response?.data?.message)
        } catch (error) {
            console.log("Api Calling Error:", error.message)
            toast.error(error.message)
        }
    }
}
